export default "__VITE_ASSET__DOMe5PXo__";